/**
 * Created by jerry on 2017/4/14.
 */
var SIGN_REGEXP = /([yMdhsm])(\1*)/g
var DEFAULT_PATTERN = 'yyyy-MM-dd'

import Vue from 'vue'
import storage from "./storage.js"
import configs from "../configs/configs.js";
import request from "../models/request.js";


Vue.prototype.highPrecisionAdd = function(data1, data2) { // 加法
    let r1, r2, m;
    // 获取每个参数的小数的位数
    try { r1 = data1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = data2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    // 计算底数为10以最大小数位数为次幂的值
    m = Math.pow(10, Math.max(r1, r2));
    // 把所有参数转为整数后相加再除以次幂的值
    return (data1 * m + data2 * m) / m;
};

Vue.prototype.highPrecisionReduce = function(data1, data2) { // 减法
    let r1, r2, m, n;
    // 获取每个参数的小数的位数
    try { r1 = data1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = data2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    // 计算底数为10以最大小数位数为次幂的值
    m = Math.pow(10, Math.max(r1, r2));
    //精度长度以最大小数位数为长度
    n = (r1 >= r2) ? r1 : r2;
    return ((data1 * m - data2 * m) / m).toFixed(n);
};

Vue.prototype.highPrecisionMul = function(data1, data2) { // 乘法
    let m = 0,
        s1 = data1.toString(),
        s2 = data2.toString();
    // 获取所有参数小数位长度之和
    try { m += s1.split(".")[1].length } catch (e) {}
    try { m += s2.split(".")[1].length } catch (e) {}
    // 替换掉小数点转为数字相乘再除以10的次幂值
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};

Vue.prototype.highPrecisionDiv = function(data1, data2) { // 除法
    let t1 = 0,
        t2 = 0,
        r1, r2;
    // 获取每个参数的小数的位数
    try { t1 = data1.toString().split(".")[1].length } catch (e) {}
    try { t2 = data2.toString().split(".")[1].length } catch (e) {}
    // 把所有参数的小数点去掉转为整数
    r1 = Number(data1.toString().replace(".", ""));
    r2 = Number(data2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
};

export default {
    // 深拷贝
    deepCopy(params) {
        return JSON.parse(JSON.stringify(params));
    },
    // 获取角色字典
    async getAuthGroups() {
        let groupsData = [],
            params = {
                is_disable: '0'
            }

        await request.role.list(params).then(res => {
            groupsData = res.data_list || []
        }).catch(() => {
            groupsData = []
        })

        return groupsData
    },
    /**
     * 获取操作人、创建人列表
     * @param {*} type 列表类型 必须
     */
    async getOperators(type) {
        let groupsData = [],
            params = {
                type: type
            }

        await request.productCategorys.operators(params).then(res => {
            groupsData = res || []
        }).catch(() => {
            groupsData = []
        })

        return groupsData
    },
    /**
     * 获取产品分类列表
     * @param {*} level 产品层级 必须
     * @param {*} pid 父级分类 非必须
     */
    async getProductCategories(level, pid, isDisable) {
        let groupsData = [],
            params = {
                page_size: 0,
                level: level
            }
        
        if (pid)  params.parent_id = pid
        if (isDisable) params.is_disable = isDisable

        await request.common.productCategories(params).then(res => {
            groupsData = res.data_list || []
        }).catch(() => {
            groupsData = []
        })

        return groupsData
    },
    /**
     * 产品服务类型列表
     * @param {*} id 产品分类id 必须
     */
    async getServiceTypes(id) {
        let groupsData = []

        await request.common.serviceTypes(id).then(res => {
            groupsData = res || []
        }).catch(() => {
            groupsData = []
        })

        return groupsData
    },
    // 获取区域列表
    async getAreas() {
        let groupsData = []

        await request.common.areas().then(res => {
            groupsData = res || []
        }).catch(() => {
            groupsData = []
        })

        return groupsData
    },
    // 判断是否为数组
    isArray(arr) {
        return Array.isArray(arr)
    },
    //  判断是否为数字
    isNumber(val) {
        var regPos = /^\d+(\.\d+)?$/, //非负浮点数
            regNeg = /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/; //负浮点数

        if(regPos.test(val) || regNeg.test(val)) {
            return true;
        } else {
            return false;
        }
    },
    // 判断该对象是否为空对象
    isObjectEmpty(obj) {
        let objArr = Object.keys(obj).length

        if (objArr > 0) {
            return true
        } else {
            return false
        }
    },
    // 参数格式化
    paramsFormat(params) {
        for (let i in params) {
            if (params[i] === '' || params[i] === ' ' || params[i] === undefined) {
                delete params[i]
            }
        }

        return params
    },
    // 格式化OSS图片
    ossImgForamt(src) {
        if (src.indexOf('?x-oss-process=style') > -1) {
            src = src.split('?x-oss-process=style')[0]
        }

        return src
    },
    // 各个地区手机号码验证
    phoneCheck(form) {
        let result = false

        switch (form.area_code) {
            case '86':
                result = /^[1][3-9]\d{9}$/.test(form.phone)
                break
            case '852':
                result = /^([6|9])\d{7}$/.test(form.phone)
                break
            case '853':
                result = /^[6]([8|6])\d{5}$/.test(form.phone)
                break
            case '886':
                result = /^[0][9]\d{8}$/.test(form.phone)
                break
            case '1':
                result = /^[2-9]\d{2}[2-9](?!11)\d{6}$/.test(form.phone)
                break
        }

        return result
    },
    // 导出
    listExport: function(url, params) {
        let urlLink = configs.baseURL + url
        urlLink += '?token=' + storage.getToken()
        if (params) {
            for (var i in params) {
                if (params[i]) {
                    urlLink += '&' + i + '=' + params[i]
                }
            }
        }
        return urlLink
    },
    formatDate: {
        format: function(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN
            return pattern.replace(SIGN_REGEXP, function($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length)
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length)
                    case 'd':
                        return padding(date.getDate(), $0.length)
                    case 'w':
                        return date.getDay() + 1
                    case 'h':
                        return padding(date.getHours(), $0.length)
                    case 'm':
                        return padding(date.getMinutes(), $0.length)
                    case 's':
                        return padding(date.getSeconds(), $0.length)
                }
            })
        },
        parse: function(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP)
            var matchs2 = dateString.match(/(\d)+/g)
            if (matchs1.length === matchs2.length) {
                var _date = new Date(1970, 0, 1)
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i])
                    var sign = matchs1[i]
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int)
                            break
                        case 'M':
                            _date.setMonth(_int - 1)
                            break
                        case 'd':
                            _date.setDate(_int)
                            break
                        case 'h':
                            _date.setHours(_int)
                            break
                        case 'm':
                            _date.setMinutes(_int)
                            break
                        case 's':
                            _date.setSeconds(_int)
                            break
                    }
                }
                return _date
            }
            return null
        }
    },
    /**
     * 检出原数组被删除的选项
     * @param {*} originalData 原数组
     * @param {*} newData 新数组
     * @param {*} key 用来对比的键
     */
    notExistArray(originalData, newData, key) {
        const deleteData = []
        const oldData = originalData
        oldData.forEach(original => {
            let isVaild = false
            newData.forEach(item => {
                if (
                    original[key] == '' ||
                    Number(original[key]) === Number(item[key])
                )
                    isVaild = true
            })

            if (!isVaild) {
                original.is_delete = 1
                deleteData.push(original)
            }
        })

        return JSON.parse(JSON.stringify([...newData, ...deleteData]))
    },
    // 检查链接是否合法
    validateUrl(url) {
        var reg = /(http|https|ftp):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
        return reg.test(url)
    },
    // 拷贝对象
    copyArr(arr) {
        return arr.map((e) => {
            if (typeof e === 'object') {
                return Object.assign({}, e)
            } else {
                return e
            }
        })
    },
    // 构造服务类型上传文件数据
    serviceTypesUpload(arr) {
        let array = JSON.parse(JSON.stringify(arr))
        
        array.forEach(ele => {
            switch (ele.code) {
                case 'TAG0301':
                    ele.uploadLoading = false
                    ele.uploadName = '安装图'
                    ele.uploadId = 'file_id'
                    ele.uploadArray = []
                    ele.uploadList = 'fileList'
                    break
                case 'TAG0302':
                    ele.uploadLoading = false
                    ele.uploadName = '维修图'
                    ele.uploadId = 'repair_file_id'
                    ele.uploadArray = []
                    ele.uploadList = 'repairFileList'
                    break
                case 'TAG0303':
                    ele.uploadLoading = false
                    ele.uploadName = '清洗图'
                    ele.uploadId = 'wash_file_id'
                    ele.uploadArray = []
                    ele.uploadList = 'washFileList'
                    break
            }
        });

        return array;
    },
    // 构造服务类型产品数据
    serviceTypesProduct(arr) {
        let array = JSON.parse(JSON.stringify(arr))

        array.forEach(ele => {
            ele.serviceName = ele.name
            switch (ele.code) {
                case 'TAG0301':
                    ele.uploadLoading = false
                    ele.tabsName = '安装项'
                    ele.labelName = '安装项产品名称'
                    ele.name = ''
                    ele.detail = ''
                    ele.description = ''
                    ele.is_recommend = true
                    ele.images = [
                        {        
                            uploadName: '安装项产品图',
                            uploadArray: []
                        }
                    ]
                    break
                case 'TAG0302':
                    ele.uploadLoading = false
                    ele.tabsName = '维修项'
                    ele.labelName = '维修项产品名称'
                    ele.name = ''
                    ele.detail = ''
                    ele.description = ''
                    ele.is_recommend = true
                    ele.images = [
                        {        
                            uploadName: '维修项产品图',
                            uploadArray: []
                        }
                    ]
                    break
                case 'TAG0303':
                    ele.uploadLoading = false
                    ele.tabsName = '清洗项'
                    ele.labelName = '清洗项产品名称'
                    ele.name = ''
                    ele.detail = ''
                    ele.description = ''
                    ele.is_recommend = true
                    ele.images = [
                        {        
                            uploadName: '清洗项产品图',
                            uploadArray: []
                        }
                    ]
                    break
            }
        });

        return array;
    },
    // 映射服务类型
    mapServiceTypes(codeArray) {
        let arr = storage.getTags('serve_type'),
            obj = {},
            valArray = []

        arr.forEach(ele => {
            obj[ele.code] = ele
        });

        for (let index = 0; index < codeArray.length; index++) {
            const element = codeArray[index];
            
            valArray.push(obj[element].name)
        }

        return valArray.join('、')
    },
    // 获取服务类型code
    geterviceTypesCode() {
        let arr = storage.getTags('serve_type'),
            codeArr = []

        arr.forEach(ele => {
            codeArray.push(ele.code)
        });

        return codeArray
    },
    // 分页配置
    pageConfig(data) {
        return {
            loading: false,
            pageSize: data.page_size,
            total: data.count,
            currentPage: data.page_no,
            tableData: JSON.parse(JSON.stringify(data.data_list)) || [],
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/util.js